





































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import { validateRequired, validateType } from '@/components/UI/Form/Validations';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { GQL_recurringOrder_recurringOrder_recurringOrderSetting } from '@/queries/__generated__/recurringOrder';
import { recurrenceIntervals } from '@/app/RecurringOrder';

@Component
export default class RecurringOrderSettingForm extends Vue {
  @Prop(Object) private recurringOrderSetting!: GQL_recurringOrder_recurringOrder_recurringOrderSetting;

  @PropSync('valid', { type: Boolean, default: true }) private validFormSync!: boolean;

  private recurrenceIntervals = recurrenceIntervals;

  private rules: IRules = {
    interval: [
      {
        validation: ({ dataValue }) => {
          return this.recurrenceIntervals.includes(dataValue);
        },
        message: i18n => i18n.t('Error.required', { field: this.t_attr('RecurringOrderSetting', 'interval') }),
      },
    ],
    startDate: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('RecurringOrderSetting', 'startDate') }),
      },
      {
        validation: validateType('date'),
        message: i18n => i18n.t('GQL.Type.date'),
      },
    ],
    endDate: [
      {
        validation: ({ dataValue, formElements }) => {
          if (!formElements?.startDate?.dataValue || !dataValue) return true;
          return formElements.startDate.dataValue < dataValue;
        },
        message: i18n => i18n.t('Error.mustBeSameOrAfter', {
          beforeField: this.t_attr('RecurringOrderSetting', 'startDate'),
          afterField: this.t_attr('RecurringOrderSetting', 'endDate'),
        }),
        triggerBy: [ 'startDate' ],
      },
      {
        validation: ({ dataValue }) => {
          if (!dataValue || !this.recurringOrderSetting.lastDateCreatedOn) return true;

          return this.$dayjs.strict(dataValue).isSameOrAfter(this.recurringOrderSetting.lastDateCreatedOn);
        },
        message: i18n => i18n.t('Error.mustBeSameOrAfter', {
          beforeField: this.recurringOrderSetting.lastDateCreatedOn,
          afterField: this.t_attr('RecurringOrderSetting', 'endDate'),
        }),
        triggerBy: [ 'startDate' ],
      },
      {
        validation: validateType('date'),
        message: i18n => i18n.t('GQL.Type.date'),
      },
    ],
    dateOffset: [
      {
        validation: validateType('number'),
        message: i18n => i18n.t('GQL.Type.uint'),
      },
    ],
  };
}
